// extracted by mini-css-extract-plugin
export default {"sort":"BR-z","sortSelect":"CR-z","disabled":"DR-z"};